export default __webpack_public_path__ + "static/media/ge.d0add9d0.svg";